import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="listmodal"
export default class extends Controller {
  connect() {
    // const modal = document.querySelector('.advanced-search-modal');
    const content = this.element.querySelector('.wishlist-modal__content');
    this.element.addEventListener('click', (e) => {
      if(!content.contains(e.target)){
        this.element.classList.remove('open');
      }
    })
  }
}
